<template>
<div :class="$style.container" class="center" ref="container" :hidden="!show">
    <div style="height:21%;" class="showInLargeb"></div>
    <div style="height:30px;" class="showInSmallb"></div>
    <div :class="$style.box" class="center dib">
        <logo :height="42" style="margin-top: 80px;"></logo>
        <!-- 登錄選項 -->
        <template v-if="step === 0" >
            <p class="fw500 fs24" style="margin-top:10px;">{{$t('signinadd1')}}</p>
            <div style="margin: 40px 10%;">
                <div>
                    <el-button type="primary" :class="$style.button1" @click="step = 1">{{ $t('signinadd2') }}</el-button>
                </div>
                <div>
                    <el-button type="info" :class="$style.button2" @click="toDomestic">{{ $t('signinadd3') }}</el-button>
                </div>
                <div>
                    <el-button type="info" :class="$style.button2" @click="toAdmin">{{ $t('signinadd4') }}</el-button>
                </div>
                <p style="margin-top:20px;" class="left">
                    <span class="blue cp" style="font-size: 12px;" @click="skip">{{$t('skip')}}</span>
                </p>
            </div>
        </template>
        <!-- 客戶登入 -->
        <template v-else-if="step === 1">
            <p class="fw500 fs24" style="margin-top:10px;">{{$t('signin')}}</p>
            <div style="width: 80%;margin: 20px auto;" class="blueinput">
                <el-input v-model="model.mobile" :placeholder="$t('phone1')"></el-input>
                <el-input v-model="model.password" show-password :placeholder="$t('password')" style="margin-top:25px;margin-bottom: 25px;"></el-input>
                <div class="dflex gray" style="font-size: 12px; margin-bottom: 10px;">
                    <p @click="step = 2" class="f1 left cp">{{ $t('signinadd6') }}</p>
                    <p class="f1" style="text-align: right;">
                        {{$t('noaccount')}} <span class="blue cp" @click="$router.push('/signup')">{{$t('signup')}}</span>
                    </p>
                </div>
                <p v-if="err" class="red">{{err}}</p>
                <el-button type="primary" style="padding: 14px; width: 100%;" @click="onSigninClick" :disabled="!canSubmit">{{ $t('signin').toUpperCase() }}</el-button>
                <div class="left gray" style="font-size: 12px;padding-bottom: 20px;padding-top:10px;">
                    <p> <span class="blue cp" @click="step = 0">{{$t('signinadd5')}}</span></p>
                </div>
            </div>
        </template>
        <!-- 找回密碼 -->
        <template v-else-if="step === 2">
            <p class="fw500 fs24" style="margin-top:10px;">{{$t('signinadd6')}}</p>
            <div style="margin: 40px 10%;">
                <div class="dflex pr">
                    <span v-if="codeErr" class="red pa" style="right: 0px;bottom: -25px; font-size: 12px;">{{ codeErr }}</span>
                    <el-select v-model="areaCode" :placeholder="$t('areaCode')" style="width: 40%; padding-right: 10px;">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                    <el-input v-model="phone" :placeholder="$t('phone1')"></el-input>
                </div>
                <el-input v-model="findPasswordModel.code" :placeholder="$t('certify')" style="margin-top:25px;width: calc(100% - 140px);" class="dib"></el-input>
                <el-button type="primary" :disabled="!canSendCertify" @click="getCertify" style="width: 130px;
        padding: 12px 0px;margin-left:10px;">{{ time > 0 ? time : $t('getCertify') }}</el-button>
                <el-input v-model="findPasswordModel.password" show-password :placeholder="$t('password1')" style="margin-top:25px;"></el-input>
                <el-input v-model="findPasswordModel.confirm_password" show-password :placeholder="$t('password2')" style="margin-top:25px;margin-bottom: 25px;"></el-input>
                <p v-if="err" class="red" style="font-size: 12px;">{{err}}</p>
                <el-button type="primary" style="padding: 14px; width: 100%;" @click="onFindPasswordClick" :disabled="!canFindPassword">{{ $t('signinadd7') }}</el-button>
                <div class="left gray" style="font-size: 12px;padding-bottom: 20px;padding-top:10px;">
                    <p> <span class="blue cp" @click="step = 1">{{$t('signinadd8')}}</span></p>
                </div>
            </div>
        </template>
        <!-- 找回密碼成功 -->
        <div v-else-if="step === 3" style="margin: 40px 10%;">
            <p style="margin-top: 20px;">{{ $t('password3') }}</p>
            <p style="margin-bottom: 30px;">{{ $t('password4') }}</p>
            <el-button type="primary" style="padding: 14px; width: 100%;" @click="step=1">{{ $t('aperson') }}</el-button>
        </div>
    </div>
</div>
</template>
<script>
export default {
    name: 'Signin',
    data() {
        return {
            step: 0,
            model: {
                mobile: '',
                password: '',
            },
            findPasswordModel: {
                mobile: '',
                password: '',
                confirm_password: '',
                code: '',
                code_id: '',
            },
            err: '',
            codeErr: '',
            areaCode: '852',
            phone: '',
            time: 0,
            options: [{label: '852', value: '852'}],
            show: false,
        };
    },
    computed: {
        canSubmit() {
            return this.model.mobile && this.model.password;
        },
        canSendCertify() {
            return this.areaCode && this.phone && this.time <= 0;
        },
        canFindPassword() {
            return this.areaCode && this.phone && this.findPasswordModel.password && this.findPasswordModel.confirm_password && this.findPasswordModel.code && this.findPasswordModel.code_id;
        }
    },
    created() {
        this.$service.getPic().then((res) => {
            if (res.data && res.data.bg_picture) {
                this.$refs.container.style.backgroundImage = 'url('+ res.data.bg_picture + ')';
            }
            this.show = true;
        }).catch(() => {
            this.show = true;
        });
    },
    methods: {
        onSigninClick() {
            this.$service.login(this.model).then(() => {
                this.$router.push('/index');
            }).catch((err) => {
                this.err = err.message;
            });
        },
        toAdmin () {
            window.location = 'https://www.goldenwin.com.hk/admin';
        },
        toDomestic () {
            window.location = 'https://www.goldenwin.com.hk/helper/signin';
        },
        skip() {
            this.$router.go(-1);
        },
        countTime() {
            this.time = 60;
            const fun = () => {
                if (this.time > 0) {
                    setTimeout(() => {
                        this.time = this.time - 1;
                        fun();
                    }, 1000);
                }
            };
            fun();
        },
        getCertify() {
            this.codeErr = '';
            this.countTime();
            this.$service.getCode({
                mobile: this.areaCode + this.phone
            }).then((res) => {
                this.findPasswordModel.code_id = res.data.code_id;
            }).catch((err) => {
                this.codeErr = err.message;
            })
        },
        onFindPasswordClick() {
            this.err = '';
            this.findPasswordModel.mobile = this.phone;
            this.$service.findPassword(this.findPasswordModel).then(() => {
                this.step = 3;
            }).catch((err) => {
                this.err = err.message;
            });
        }
    }
}
</script>
<style module>
.container {
    height: 100%;
    background: url(../assets/signin.jpg) no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
}
.box {
    background: #fff;
    width: 40%;
    min-width: 339px;
    margin: 0px auto;
    opacity: 0.96;
}
.button1 {
    width: 100%;
    height: 100px;
}
.button2 {
    width: 100%;
    margin-top: 20px !important;
}
</style>
